import { Values } from '@pes-ui/utils';

// TODO: move this utils to conv-ui and bundle them separately so this lib is able to use them
export const expAPIEndpoint = {
  PDP_ALL_SPRYKER: 'pdp_all_spryker',
  DDC_COMMON_SPRYKER: 'ddc_common_spryker',
  PRODUCT_CARD_SPRYKER: 'product_card_spryker',
  ALL_PRODUCTS_SPRYKER: 'all_products_spryker',
  PRODUCT_SELECTOR_SPRYKER: 'product_selector_spryker',
  RANGES_ALL_SPRYKER: 'ranges_all_spryker',
  CATEGORIES_ALL_SPRYKER: 'categories_all_spryker',
  SUBCATEGORIES_ALL_SPRYKER: 'subcategories_all_spryker',
  RM_EPDS: 'rm-epds',
} as const;

let languageCode: string;
let countryCode: string;
let host: string;
let brand: string;

const template = (literals: TemplateStringsArray, ...substitutions: string[]): string => {
  let result = '';

  for (let i = 0; i < substitutions.length; i++) {
    result += literals[i];
    result += substitutions[i];
  }

  result += literals[literals.length - 1];

  return result;
};

type TTemplateOptions = {
  productId?: string;
  businessId?: string;
  categoryId?: string;
  subcategoryId?: string;
  rangeId?: string;
};

type TTemplateFunction = (options: TTemplateOptions) => string;

type TURLMap = Record<Values<typeof expAPIEndpoint>, TTemplateFunction>;

const urlMap: TURLMap = {
  [expAPIEndpoint.PDP_ALL_SPRYKER]: ({ productId }) =>
    template`${host}/products/${productId}/all?brand=${brand}&country-code=${countryCode}&language-code=${languageCode}`,
  [expAPIEndpoint.DDC_COMMON_SPRYKER]: () =>
    template`${host}/ddc-config?brand=${brand}&country-code=${countryCode}&language-code=${languageCode}`,
  [expAPIEndpoint.PRODUCT_CARD_SPRYKER]: () =>
    template`${host}/products-card/main?country-code=${countryCode}&language-code=${languageCode}&brand=${brand}&ids=`,
  [expAPIEndpoint.ALL_PRODUCTS_SPRYKER]: () =>
    template`${host}/allproducts-all?brand=${brand}&country-code=${countryCode}&language-code=${languageCode}`,
  [expAPIEndpoint.PRODUCT_SELECTOR_SPRYKER]: () =>
    template`${host}/products-selector/config?brand=${brand}&country-code=${countryCode}&language-code=${languageCode}`,
  [expAPIEndpoint.CATEGORIES_ALL_SPRYKER]: ({ categoryId }) =>
    template`${host}/categories/${categoryId}/all?brand=${brand}&country-code=${countryCode}&language-code=${languageCode}`,
  [expAPIEndpoint.SUBCATEGORIES_ALL_SPRYKER]: ({ subcategoryId }) =>
    template`${host}/subcategories/${subcategoryId}/all?brand=${brand}&country-code=${countryCode}&language-code=${languageCode}`,
  [expAPIEndpoint.RANGES_ALL_SPRYKER]: ({ rangeId }) =>
    template`${host}/ranges/${rangeId}/all?brand=${brand}&country-code=${countryCode}&language-code=${languageCode}`,
  [expAPIEndpoint.RM_EPDS]: ({ productId }) =>
    template`${host}/epds?id=${productId}&country-code=${countryCode}&language-code=${languageCode}&brand=se`,
};

type InitOptions = {
  languageCode: string;
  countryCode: string;
  host: string;
  pathName: string;
  externalHost?: string;
  brand?: string;
};

export const initExpAPIEndpointURLBuilder = (options: InitOptions): void => {
  ({ countryCode, languageCode, host, brand } = options);
};

export const getExpAPIEndpointURL = (
  type: Values<typeof expAPIEndpoint>,
  options: TTemplateOptions = {},
): string => {
  return urlMap[type](options);
};
